var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotifications = function SvgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#notifications_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0M2 16h10a2 2 0 0 0 2-2V8h-2v6h-1.056c-.318-1.7-1.966-3-3.944-3s-3.626 1.3-3.944 3H2V4h6V2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2m3-8c0 1.102.898 2 2 2s2-.898 2-2-.898-2-2-2-2 .898-2 2",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "notifications_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgNotifications;